module.exports = __webpack_public_path__ + "static/media/refresh.d0652e40.svg";